import React, { useEffect } from "react";
import IconifyIcon from "../../icons/Icon";

const NftInteractionModal = ({ content, width, custom, handleClose, outsideClick = true }) => {
  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget && outsideClick) {
      handleClose();
    }
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      onClick={handleOutsideClick}
      className="fixed top-0 left-0 w-full h-full flex items-center justify-center overflow-y-auto bg-opacity-50 bg-gray-900 z-50 backdrop-blur-lg"
    >
      <div
        className={`${width} relative border border-yellow-300 rounded-[18px] flex justify-center bg-black overflow-hidden`}
      >
        {!custom && (
          <button
            type="button"
            className="flex justify-center items-center absolute top-7 right-6"
            onClick={handleClose}
          >
            <IconifyIcon
              className="text-white "
              height={34}
              width={34}
              icon="system-uicons:cross-circle"
              color="white"
            />
          </button>
        )}

        {content}
      </div>
    </div>
  );
};

export default NftInteractionModal;
